import {MathUtils,Quaternion,Vector3,type Bone,type Object3D} from 'three';

export const FLIGHT_AIM_HANDOFF=.28;

/** Blend finished poses, after aim/IK, rather than running the aim solvers on a
 * partly inverted flight clip. A reversal captures the currently visible pose. */
export class FlightAimTransition {
  private readonly pose:{bone:Bone;position:Vector3;rotation:Quaternion;scale:Vector3}[]=[];
  private readonly target=new Quaternion();
  private readonly rootPosition=new Vector3();
  private readonly rootRotation=new Quaternion();
  private root:Object3D|null=null;
  elapsed=FLIGHT_AIM_HANDOFF;
  get active():boolean{return this.elapsed<FLIGHT_AIM_HANDOFF;}
  begin(bones:readonly Bone[],root:Object3D):void{
    this.pose.length=0;
    for(const bone of bones)this.pose.push({bone,position:bone.position.clone(),rotation:bone.quaternion.clone(),scale:bone.scale.clone()});
    this.root=root;this.rootPosition.copy(root.position);this.rootRotation.copy(root.quaternion);this.elapsed=0;
  }
  cancel():void{this.elapsed=FLIGHT_AIM_HANDOFF;this.pose.length=0;this.root=null;}
  apply(dt:number):void{
    if(!this.active)return;
    this.elapsed=Math.min(FLIGHT_AIM_HANDOFF,this.elapsed+MathUtils.clamp(Number.isFinite(dt)?dt:0,0,.1));
    const k=MathUtils.smootherstep(this.elapsed,0,FLIGHT_AIM_HANDOFF);
    for(const {bone,position,rotation,scale}of this.pose){
      this.target.copy(bone.quaternion);bone.quaternion.slerpQuaternions(rotation,this.target,k);
      bone.position.lerpVectors(position,bone.position,k);bone.scale.lerpVectors(scale,bone.scale,k);
    }
    if(this.root){
      this.target.copy(this.root.quaternion);this.root.quaternion.slerpQuaternions(this.rootRotation,this.target,k);
      this.root.position.lerpVectors(this.rootPosition,this.root.position,k);
    }
    if(!this.active)this.cancel();
  }
}
